import Model from '@models/model';

export default class VirtualOrder extends Model {
    resource() {
        return 'virtual-orders';
    }
}
